import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openModal(event) {
    const productId = event.currentTarget.dataset.productId
    const productName = event.currentTarget.dataset.productName

    const form = document.getElementById('product-duplicate-form')
    if (form) {
      form.action = `/products/duplicate_notifications?product_id=${productId}`
    }

    window.dispatchEvent(new CustomEvent('open-product-duplicate-modal', {
      detail: { productId: productId, productName: productName }
    }))
  }
}
